import { useLoad } from "../lib/api.jsx";
import { Wait, Tbl, bytes } from "../lib/ui.jsx";

export default function Files() {
  const [d] = useLoad("files_overview");
  return (
    <>
      <h1>File overview</h1>
      <Wait d={d}>
        {d && !d.error && (
          <>
            <div className="stats">
              {d.sets.map((s) => (
                <div className="stat" key={s.name}>
                  <b>{s.files}</b>
                  <span>{s.name} ({s.active} active){s.bytes != null ? ` - ${bytes(s.bytes)}` : ""}</span>
                </div>
              ))}
              <div className="stat"><b>{d.queue.pending}</b><span>Files waiting to move ({d.queue.failing} failing)</span></div>
            </div>
            <h2>Top uploaders (pictures)</h2>
            <Tbl rows={d.uploaders.map((r, i) => ({ ...r, id: i }))} empty="No uploads yet." cols={[
              ["User", (r) => r.Name || r.poster], ["Files", (r) => r.files], ["Storage used", (r) => bytes(r.bytes)],
            ]} />
          </>
        )}
      </Wait>
    </>
  );
}
